import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getProjectScoreCardsSummary';

export const getProjectScoreCardsSummary = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
